export default "__VITE_ASSET__6RqyLLGx__"